import { Injectable } from '@angular/core';
import { CheckoutQuantityValidationService, ValidationResult, ValidationRequest, CartListCheckoutConfigService } from 'gung-standard';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ColmecCheckoutQuantityValidationService extends CheckoutQuantityValidationService {
  constructor(protected translateService: TranslateService, protected cartListCheckoutConfigService: CartListCheckoutConfigService) {
    super(translateService, cartListCheckoutConfigService);
  }

  /**
   *
   * Making sure the behavior at colmec doesnt change when standard validation is imporved
   *
   */
  public getQtyValidationResult(validationRequest: ValidationRequest): ValidationResult {
    const validationResult: ValidationResult = {
      row: validationRequest.row,
      product: validationRequest.product,
      availability: validationRequest.availability,
      valid: true,
      actions: []
    };

    if (validationRequest.availability.currentAvailability < validationRequest.row.quantity) {
      validationResult.valid = false;
      const availabilityValue = Math.round(validationResult.availability.currentAvailability);
      validationResult.description =
        this.translateService.instant('NOT_ENOUGH_AVAILABILITY') +
        ' (' +
        validationResult.row.quantity +
        '>' +
        availabilityValue +
        ')';
      validationResult.actions.push(super.getLowerAvailabilityAction(validationResult));
      validationResult.actions.push(super.getRemoveProductAction(validationResult));
      validationResult.selectedAction = validationResult.actions[0];
    }

    return validationResult;
  }
}
